<template>
  <!-- 个人中心首页 -->
  <div class="bgs">
      <div class="Home">
          <div class="Home_top">
            <div class="home_top_list">
                <div class="home_top_list_top">
                  <img src="../../assets/img/Personal/bg1_icon.png" alt="">专利发表（件）
                </div>
                <div class="home_top_list_bottom">
                  {{Lists.patent_num}}
                </div>
            </div>
             <div class="home_top_list">
                <div class="home_top_list_top">
                  <img src="../../assets/img/Personal/bg1_icon.png" alt="">研报发表（篇）
                </div>
                <div class="home_top_list_bottom">
                  {{Lists.report_num}}
                </div>
            </div>
             <div class="home_top_list">
               <div class="home_top_list_top">
                  <img src="../../assets/img/Personal/bg1_icon.png" alt="">资讯发表（篇）
                </div>
                <div class="home_top_list_bottom">
                  {{Lists.article_count}}
                </div>
            </div>
          </div>
          <div class="Home_bottom">
              <div class="Home_bottom_list">
                  <img src="../../assets/img/Personal/fensi_icon.png" alt="">
                  <span>粉丝数</span>
                  <p>{{Lists.fans}}</p>
              </div>
              <div class="Home_bottom_list">
                  <img src="../../assets/img/Personal/yueduliang_icon.png" alt="">
                  <span>总阅读量</span>
                  <p>{{Lists.pv}}</p>
              </div>
              <div class="Home_bottom_list">
                  <img src="../../assets/img/Personal/pinglunshu_icon.png" alt="">
                  <span>评论数</span>
                  <p>{{Lists.comment_num}}</p>
              </div>
          </div>
          <!-- 账号类型 -->
          <div class="account_type">
            <!-- 普通用户 -->
              <div class="Ordinary_users" v-if="isbusiness==0">
                <div class="Ordinary_users_left">
                  尊敬的用户： 您的账号类型为：<span style="color:#E95555 ;">普通用户</span>，无法发布内容。
                </div>
                <div class="Ordinary_users_right" v-if="isbusiness==0&&isapply_info==0" @click="ApplicationExpert">
                  申请专家/机构认证 >
                </div>
                <div class="Ordinary_users_right" v-if="isapply_info==1&&UserInfo_status!=2" @click="ApplicationExpert1">
                  查看专家认证信息 >
                </div>
                <div class="Ordinary_users_right" v-if="isapply_info==2&&UserInfo_status!=2" @click="ApplicationExpert2">
                  查看机构认证信息 >
                </div>
              </div>
            <!-- 认证专家 -->
            <div class="Certified_Expert" v-if="isbusiness==1">
            <div>尊敬的用户： 您的账号类型为：<span style="color:#E98A55;">认证专家</span></div>
            <div style="color:#E98A55;cursor: pointer;" @click="ViewAuthentication1">查看认证信息></div>
            </div>
            <!-- 认证机构 -->
            <div class="Certification_body" v-if="isbusiness==2">
            <div>尊敬的用户： 您的账号类型为：<span style="color:#5179DD;">认证机构</span></div>
            <div style="color:#5179DD;cursor: pointer;"  @click="ViewAuthentication2">查看认证信息></div>
            </div>
          </div>
          <!-- 站内公告 -->
          <div class="Station_announcement">
            <div class="Station_announcement_title">
              <div class="Station_announcement_title_left">站内公告</div>
              <div class="Station_announcement_title_right" @click="Go_Notices">查看更多 ></div>
            </div>

            <div class="Station_announcement_list" v-for="(item,index) in temp" v-if="index<10" :key="index" @click="Go_Notice(item.id)">
                <div class="Station_announcement_list_left">
                  <div class="Station_announcement_list_left_z" v-if="item.type==0">默认</div>
                  <div class="Station_announcement_list_left_z" v-if="item.type==1" style="background:#B36CEF">热点</div>
                  <div class="Station_announcement_list_left_z" v-if="item.type==2" style="background:#E98A55;">推荐</div>
                  <div class="Station_announcement_list_left_y">{{item.title}}</div>
                </div>
                <div class="Station_announcement_list_right">
                      <div class="Station_announcement_list_right_z">{{item.create_time}}</div>
                      <div class="Station_announcement_list_right_y">...</div>
                </div>
            </div>
          </div>
          
      </div> 
  </div>
</template>

<script>
import Axios from "axios"
import {userInfos} from "@/api/api"
export default {
  metaInfo(){
     return{
        title: '个人中心',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
  data(){
    return{
        list:[1,2,3,4,5,6,7,8,9,10],
        isbusiness:'',
        isapply_info:'',
        UserInfo_status:'',
        Lists:'',
        temp:[],
    }
  },
  methods:{
    ApplicationExpert(){
     this.$router.push({ path: '/IdAuthentication' })
    },
    ApplicationExpert1(){
     this.$router.push({ path: '/ExpertCertification' })
    },
    ApplicationExpert2(){
     this.$router.push({ path: '/AgencyCertification' })
    },
    ViewAuthentication1(){
      this.$router.push({ path: '/RZExpertCertification' })
    },
    ViewAuthentication2(){
      this.$router.push({ path: '/RZAgencyCertification' })
    },
    Go_Notices(){
      this.$router.push({ path: '/Notice' })
    },
    Go_Notice(id){
        this.$router.push({path: '/NoticeDetails',query: { id:id }})
    },
     getComments() {
          Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/announcement/index",
      params: {
          content_type:this.content_type,status:this.status,page:this.page,limit:this.limit
      },
      headers: {
          token: localStorage.getItem("token"),
        },
    }).then((res) => {
        ////console.log(res);
     this.temp = res.data.data.data;
    });
  },
  },
  created(){
      this.getComments();
     userInfos({}).then((res) => {
      //console.log(res);
      //  0普通
      // 1专家
      // 2机构
      this.Lists=res.data.data;
     this.isbusiness = res.data.data.business;
      this.isapply_info=res.data.data.apply_info;
      this.UserInfo_status=res.data.data.UserInfo_status;
      // if (isbusiness == 0) {
      //   this.$confirm("您认证的信息还未通过暂时无法发布", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   })
      //     .then(() => {
      //       this.$router.push({ path: "/PersonalCenter/index" });
      //     })
      //     .catch(() => {
      //       this.$router.push({ path: "/PersonalCenter/index" });
      //     });
      // }
    });
  }
}
</script>

<style scoped>
.bgs{
  width:940px;
  background:#fff;
  padding:30px;
}
.Home_top{
  display:flex;
  justify-content: space-between;
}
.home_top_list:nth-child(1){
  width:284px;
  height:160px;
    background-image: url("../../assets/img/Personal/bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.home_top_list:nth-child(2){
  width:284px;
  height:160px;
    background-image: url("../../assets/img/Personal/bg2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.home_top_list:nth-child(3){
  width:284px;
  height:160px;
    background-image: url("../../assets/img/Personal/bg3.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.home_top_list{ 
  padding:0 27px;
  box-sizing: border-box;
}
.home_top_list_top{
  display:flex;
  margin-top:47px;
  font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
}
.home_top_list_top img{
  width:18px;
  height:20px;
  margin-right:20px;
}
.home_top_list_bottom{
  font-size: 40px;
font-family: PingFang SC;
font-weight: 800;
color: #FFFFFF;
}
.Home_bottom{
  margin-top:20px;
  display:flex;
  justify-content: space-between;
}
.Home_bottom_list:nth-child(1){
    width: 284px;
height: 60px;
background: #7AB6EE;
border-radius: 4px;
  display:flex;
  align-items: center;
  padding:0 27px;
  box-sizing: border-box; 
}
.Home_bottom_list:nth-child(2){
    width: 284px;
height: 60px;
background: #D9A2F7;
border-radius: 4px;
  display:flex;
  align-items: center;
  padding:0 27px;
  box-sizing: border-box; 
}
.Home_bottom_list:nth-child(3){
    width: 284px;
height: 60px;
background: #F4C580;
border-radius: 4px;
  display:flex;
  align-items: center;
  padding:0 27px;
  box-sizing: border-box; 
}
.Home_bottom_list:nth-child(1) img{
  width:20px;
  height:20px;
  margin-right:18px;
}
.Home_bottom_list:nth-child(2) img{
  width:24px;
  height:16px;
  margin-right:18px;
}
.Home_bottom_list:nth-child(3) img{
  width:20px;
  height:16px;
  margin-right:18px;
}
.Home_bottom_list span{
  font-size: 16px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
margin-right:35px;
}
.Home_bottom_list p{
  font-size: 28px;
font-family: PingFang SC;
font-weight: 800;
color: #FFFFFF;
 overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
/* 账号类型 */
.account_type{
 margin:30px 0;
height: 48px;
background: #FFF2E5;
border-radius: 4px;
}
.Ordinary_users{
  display:flex;
  height: 48px;
  align-items: center;
  justify-content: space-between;
  padding:0 25px;
  box-sizing: border-box;
}
.Ordinary_users_right{
  cursor: pointer;
color: #E95555;
}
.Certified_Expert{
  display:flex;
    height: 48px;
  align-items: center;
  justify-content: space-between;
   padding:0 25px;
  box-sizing: border-box;
}
.Certification_body{
   display:flex;
   justify-content: space-between;
    height: 48px;
  align-items: center;
   padding:0 25px;
  box-sizing: border-box;
}
.Station_announcement_title{
  display:flex;
  justify-content: space-between;
  margin-bottom:20px;
}
.Station_announcement_title_left{
font-size: 24px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
}
.Station_announcement_title_right{
  width: 90px;
height: 35px;
background: #E5F2FF;
border-radius: 2px;
text-align:center;
line-height:35px;
font-size: 14px;
cursor: pointer;
color:#333333;
}
.Station_announcement_list{
  margin:10px 0;
  height: 44px;
background: #F4F4F4;
border-radius: 2px;
display:flex;
justify-content: space-between;
align-items: center;
cursor: pointer;
}
.Station_announcement_list_left{
  display:flex;
  align-items: center;
}
.Station_announcement_list_right{
  display:flex;
  position:relative;
}
.Station_announcement_list_right_z{
  margin-right:90px;
  font-size: 12px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
}
.Station_announcement_list_right_y{
font-size: 20px;
    color: #999;
    right: 16px;
    top: -10px;
    position: absolute;
    cursor: pointer;
}
.Station_announcement_list_left_z{

background: #5179DD;
border-radius: 2px;
text-align:center;
padding:4px 14px;
box-sizing: border-box;
color:#fff;
margin-left:20px;
margin-right:51px;
}
.Station_announcement_list_left_y{
  font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
}
</style>